import { render, staticRenderFns } from "./DlvPL_List.vue?vue&type=template&id=67a9ae8d"
import script from "./DlvPL_List.vue?vue&type=script&lang=js"
export * from "./DlvPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports